export default function TabItemLoader() {
    return (
        <div className="flex justify-center items-center h-[200px] w-full">
            <div className="small-loader !w-[30px] !h-[30px]" />
        </div>
    );
}
